import { render, staticRenderFns } from "./PartnershipEdit.vue?vue&type=template&id=ff25be28&scoped=true"
import script from "./PartnershipEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnershipEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff25be28",
  null
  
)

export default component.exports